import { FaIdCardAlt as CargosIcon } from 'react-icons/fa'

import { Cargo, PermissaoTipo } from '@core/models/entities'
import { useAuth, useFetch } from '@presentation/hooks'
import { TablePage } from '@presentation/components/templates'
import { PageProps } from '@presentation/types/components/templates'
import {
  Filter,
  FilterProps,
  TableColumn,
  TableProps
} from '@presentation/types/components/organisms'

import {
  AddCargoModal,
  DeleteCargoModal,
  EditCargoModal,
  ReactivateCargoModal
} from './components'

const CargosPage: React.FC = () => {
  const { hasPermission } = useAuth()
  const { data, isFetching, totalItems, fetchData } = useFetch({
    path: '/cargos',
    options: { sortBy: 'nome' },
    queries: {
      status: 1
    }
  })

  const pageConfigs: PageProps = {
    icon: <CargosIcon />,
    title: 'Cargos',
    description: 'Página de gerenciamento de cargos do campus.',
    actions: hasPermission(PermissaoTipo.Escrita)
      ? [<AddCargoModal onAdd={fetchData} />]
      : []
  }

  const filters: Filter[] = [
    {
      type: {
        value: 'nome',
        label: 'Nome'
      },
      description: {
        type: 'input',
        configs: {
          type: 'text'
        }
      }
    }
  ]

  const filterConfigs: FilterProps = {
    filters,
    fetchData,
    defaultQueries: {
      status: 1
    }
  }

  const columns: Array<TableColumn<Cargo>> = [
    {
      name: 'Nome',
      selector: cargo => cargo.nome,
      sortable: true,
      center: true,
      grow: 4
    },
    {
      name: 'Ações',
      cell: cargo => (
        <>
          {cargo.status ? (
            <>
              {hasPermission(PermissaoTipo.Escrita) && (
                <EditCargoModal id={cargo.id} onEdit={fetchData} />
              )}
              {hasPermission(PermissaoTipo.Remocao) && (
                <DeleteCargoModal id={cargo.id} onDelete={fetchData} />
              )}
            </>
          ) : (
            <>
              {hasPermission(PermissaoTipo.Escrita) && (
                <ReactivateCargoModal id={cargo.id} onReactivate={fetchData} />
              )}
            </>
          )}
        </>
      ),
      center: true
    }
  ]

  const tableConfigs: TableProps = {
    columns,
    data,
    apiConfigs: {
      totalItems,
      fetchData,
      isFetching
    }
  }

  return (
    <TablePage
      pageConfigs={pageConfigs}
      filterConfigs={filterConfigs}
      tableConfigs={tableConfigs}
    />
  )
}

export default CargosPage
